export const GET_PMS_DIT_SALES_OVERVIEW_MTD = 'GET_PMS_DIT_SALES_OVERVIEW_MTD';
export const GET_PMS_DIT_SALES_OVERVIEW_MTD_SUCCESS = 'GET_PMS_DIT_SALES_OVERVIEW_MTD_SUCCESS';
export const GET_PMS_DIT_SALES_OVERVIEW_MTD_FAILURE = 'GET_PMS_DIT_SALES_OVERVIEW_MTD_FAILURE';

